<template>
  <svg
    class="right-arrow"
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.7173 12.1633L27.2651 15.7111C27.4829 15.9289 27.4829 16.2818 27.2651 16.4996L23.7173 20.0474C23.4996 20.2651 23.1466 20.2651 22.9289 20.0474C22.7112 19.8297 22.7112 19.4767 22.9289 19.259L25.525 16.6628H5.12878C4.82089 16.6628 4.57129 16.4132 4.57129 16.1053C4.57129 15.7975 4.82089 15.5479 5.12878 15.5479H25.525L22.9289 12.9517C22.7112 12.734 22.7112 12.381 22.9289 12.1633C23.1466 11.9456 23.4996 11.9456 23.7173 12.1633Z"
    />
  </svg>
</template>
<script>
export default {
  name: 'ArrowRightSvg',
  props: {
    size: {
      required: false,
      default: () => '3rem'
    }
  }
}
</script>
<style lang="sass">
.right-arrow
  fill: currentColor
</style>
